import Vue from 'vue';
import { parseFormFieldsProperties } from '../helpers/utils';

export default {
  updateSettings(state, payload) {
    // payload: color, size, classic
    state.appSettings = Object.assign({}, state.appSettings, payload);
  },
  updateUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  toggleSideNavVisibility(state) {
    Vue.set(state.sideNav, 'collapsed', !state.sideNav.collapsed);
  },
  updateSideNavItems(state, data) {
    (data || []).unshift({
      id: 0,
      name: 'الصفحة الرئيسية',
      childMenuItems: [],
      route: '/',
      properties: `{"icon":"mdi-home"}`,
    });
    if (data) {
      // eslint-disable-next-line no-param-reassign
      data = data.map(
        parentRoute => ({
          ...parentRoute,
          icon: JSON.parse(parentRoute.properties || '{}').icon || 'mdi-chevron-left',
          childMenuItems: parentRoute.childMenuItems.map(childRoute => ({
            ...childRoute,
            icon: JSON.parse(childRoute.properties || '{}').icon || 'mdi-chevron-left',
          })),
        }),
        []
      );
      Vue.set(state.sideNav, 'data', data);
    }
  },
  updateActiveNavItem(state, payload) {
    Vue.set(state.sideNav, 'activeItem', {
      ...state.sideNav.activeItem,
      ...payload,
    });
  },
  updateDataGrid(state, payload) {
    state.dataGrid = payload;
  },
  updateDataGridEndPointUrl(state, payload) {
    Vue.set(state.dataGrid, 'endPointUrl', payload);
  },
  updateDataGridSkipCastingEnabled(state, payload) {
    Vue.set(state.dataGrid, 'skipCastingEnabled', payload);
  },
  updateDataGridSkipCastingKeys(state, payload) {
    Vue.set(state.dataGrid, 'skipCastingKeys', payload);
  },
  updateDataGridFilters(state, payload) {
    state.dataGrid.filters = payload.map(filter => ({
      ...filter,
      validations: (JSON.parse(filter.properties) || {}).validations,
    }));
  },
  updateDataGridActions(state, payload) {
    state.dataGrid.actions = payload
      .sort((a, b) => a.order - b.order)
      .map(action => ({
        ...action,
        properties: JSON.parse(action.properties) || {},
        icon: (JSON.parse(action.properties) || {}).icon,
        tooltip: (JSON.parse(action.properties) || {}).tooltip,
        buttonType: 'primary',
      }));
    if (payload.length) {
      state.dataGrid.columns.unshift({
        type: 'selection',
        width: '70px',
      });
    }
  },
  updateDataGridColumns(state, payload) {
    state.dataGrid.columns = payload
      .filter(column => !column.isHidden)
      .sort((a, b) => a.order - b.order)
      .map(column => ({
        text: column.header,
        value: column.actionType ? 'action' : column.name,
        actionValue: column.actionType ? column.name : null,
        sortable: column.isSortAllowed,
        slot: column.actionType,
        httpMethod: column.httpMethod,
        actionName: column.actionName,
        className: column.actionType ? 'action-column' : '',
        width: column.actionType ? '100px' : '',
        align: 'center',
      }));
    if (state.dataGrid.actions.length) {
      state.dataGrid.columns.unshift({
        type: 'selection',
        width: '70px',
      });
    }
  },
  updateDataGridSorting(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.sorting = {
      field: payload.key,
      isDesc: payload.order === 'desc',
    };
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: 0,
    };
  },
  updateDataGridPageSize(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageSize: payload,
      pageIndex: 0,
    };
  },
  updateDataGridPageIndex(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: payload,
    };
  },
  updateDataGridSearchQuery(state, payload) {
    // state.dataGrid.items = [];
    // state.dataGrid.total = 0;
    state.dataGrid.searchQuery.paging = {
      ...state.dataGrid.searchQuery.paging,
      pageIndex: 0,
    };
    state.dataGrid.searchQuery.filters = payload;
  },
  updateDataGridItems(state, payload) {
    state.dataGrid.items = payload.items;
    state.dataGrid.total = payload.total;
  },
  addDataGridHttpRequestCancelCallback(state, payload) {
    state.dataGrid.httpRequestCancelCallbacks.push(payload);
  },
  cancelDataGridHttpRequests(state) {
    state.dataGrid.httpRequestCancelCallbacks.forEach(() => {
      state.dataGrid.httpRequestCancelCallbacks.pop()();
    });
  },
  updateAppLoader(state, payload) {
    state.appLoader = Object.assign({}, state.appLoader, payload);
  },
  updateOverlayLoader(state, payload) {
    state.overlayLoader = Object.assign({}, state.overlayLoader, payload);
  },
  clearBreadcrumbsData(state) {
    // {
    //   params: {},
    //   data: [],
    // }
    state.breadcrumbs.data = [];
  },
  updateBreadcrumbs(state, payload) {
    // {
    //   params: {},
    //   data: [],
    // }
    state.breadcrumbs.params = {
      ...state.breadcrumbs.params,
      ...payload.params,
    };
    state.breadcrumbs.data = state.breadcrumbs.data.concat(payload.data);
  },
  updateDynamicForms(state, dynamicForms) {
    state.dynamicForms = dynamicForms.map(form => ({
      ...form,
      fields: parseFormFieldsProperties(form.fields),
    }));
  },
  updateDynamicForm(state, dynamicForm) {
    const hasSelectedForm = state.dynamicForms.find(f => f.id === dynamicForm.id);
    const newForm = {
      ...dynamicForm,
      fields: parseFormFieldsProperties(dynamicForm.fields),
    };
    state.dynamicForms = hasSelectedForm
      ? state.dynamicForms.map((form) => {
        return form.id === dynamicForm.id ? newForm : form;
      })
      : state.dynamicForms.length
        ? state.dynamicForms.concat(newForm)
        : [newForm];
  },
  updatePickLists(state, pickLists) {
    state.pickLists = pickLists;
  },
  updateDynamicGrids(state, dynamicGrids) {
    state.dynamicGrids = dynamicGrids;
  },
  updateDynamicGrid(state, dynamicGrid) {
    state.dynamicGrids = state.dynamicGrids.map((form) => {
      return form.id === dynamicGrid.id ? dynamicGrid : form;
    });
  },
  updateQaimConfig(state, qaimConfigInfo) {
    state.qaimConfig = qaimConfigInfo;
  },
};
